<template>
  <div @click="exportXLSX">
    <slot name="trigger" />
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  data() {
    return {};
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    filename: {
      type: String,
      default: "Data",
    },
  },
  methods: {
    exportXLSX() {
      if (this.data && this.data.length) {
        const data = XLSX.utils.json_to_sheet(this.data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, data, "data");
        XLSX.writeFile(wb, `${this.filename}.xlsx`);
      }
    },
  },
};
</script>
<style scoped></style>
